import React, { useContext } from 'react';
import { SettingsContext } from "../SettingsContext";
import { SimpleSelect } from '../../shared/layout/forms/AppSelect';

const PeriodSelectBox = ({ value, onChange }) => {
    const { siteSettings, loading } = useContext(SettingsContext);

    if (loading) {
        return <LoadingText>Loading...</LoadingText>;
    }

    const options = (siteSettings?.periods || []).map((period) => ({
        value: period.value,
        label: period.name,
    }));

    return (
        <SimpleSelect
            value={value}
            onChange={(event, nextValue) => onChange?.({ target: { value: nextValue ?? event?.target?.value } })}
            options={options}
            inputId="period-select"
            style={{ width: 180 }}
        />
    );
};

export default PeriodSelectBox;

const LoadingText = ({ children }) => (
    <div style={{ fontSize: '1rem', color: 'rgba(130, 22, 146, 1)', fontWeight: 'bold', textAlign: 'center' }}>
        {children}
    </div>
);
